import store from 'store2';

import { IMap } from '@skippay/core/@types/common';
import { JSONType } from '@skippay/core/@types/primitives';
import { isJsonObject } from '@skippay/core/utils/objectUtils';

/**
 * Reads a per-customer JSON blob from localStorage. Returns null when nothing usable is stored.
 * A blob owned by another customer (shared device) is removed, so it never leaks across accounts.
 */
export function readCustomerMemory(key: string, customerId: string): IMap<JSONType> | null {
	try {
		const parsed: JSONType = store.local.get(key);
		if (!isJsonObject(parsed)) return null;

		if (parsed.customerId !== customerId) {
			store.local.remove(key);
			return null;
		}

		return parsed;
	} catch {
		return null;
	}
}

export function saveCustomerMemory<T>(key: string, customerId: string, memory: T): void {
	try {
		store.local.set(key, { customerId, ...memory });
	} catch {
		// localStorage not available
	}
}
